/** SA-1410: after a Reload that kept the person's edits over a newly
 * published version, the settings both of them changed — the published value
 * won there. One line under the bar's banner, each setting a link to its card. */
import type { OverlayPathDescriptor } from '@/utils/workflowConfigView'

function sentence(count: number): string {
  return count === 1
    ? '1 setting you changed was also changed in the version just published; it now shows the published value:'
    : `${count} settings you changed were also changed in the version just published; they now show the published value:`
}

export function RebaseConflictsLine({ paths, describe, onReview }: {
  paths: string[]
  describe: (path: string) => OverlayPathDescriptor
  onReview: (path: string) => void
}) {
  if (paths.length === 0) return null
  return (
    <div className="text-xs text-warning-strong">
      <p>{sentence(paths.length)}</p>
      <ul className="mt-0.5 flex flex-wrap gap-x-3 gap-y-0.5">
        {paths.map((path) => {
          const d = describe(path)
          return (
            <li key={path}>
              <button
                type="button"
                title={path}
                className={`underline underline-offset-2 ${d.resolved ? '' : 'font-mono'}`}
                onClick={() => onReview(path)}
              >
                {d.label}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
